import React from "react";
import { useWindowSize } from "react-use";

const GridImage = ({ images }) => {
  const { width } = useWindowSize();
  // const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth < 768);
  //   };
  //   handleResize();
  //   window.addEventListener("resize", handleResize);
  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, []);

  return (
    <div
      data-aos="fade-up"
      className="grid xl-plus:grid-cols-3 grid-cols-2  md:mt-[2.08vw] w-full md:gap-[2.08vw] gap-[4vw]"
    >
      {images[0] && (
        <div className=" md:h-[50vh] h-[30vh]  overflow-hidden ">
          <div className="h-full w-full hover:scale-105   transition-transform transform duration-300 ease-in-out ">
            <img
              src={`${
                width > 768
                  ? `/Gallery_img/${images[0]}.png`
                  : `/Gallery_img/mobile/${images[0]}.png`
              }`}
              alt={`Img ${images[0]}`}
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      )}
      {images[1] && (
        <div
          data-aos="fade-up"
          className=" md:h-[50vh] h-[30vh] overflow-hidden"
        >
          <div className="h-full w-full hover:scale-105   transition-transform transform duration-300 ease-in-out">
            <img
              src={`${
                width > 768
                  ? `/Gallery_img/${images[1]}.png`
                  : `/Gallery_img/mobile/${images[1]}.png`
              }`}
              alt={`Img ${images[1]}`}
              loading="lazy"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      )}

      {width > 1280
        ? images[3] && (
            <div
              data-aos="fade-up"
              className="md:row-span-2 xl-plus:col-span-1 md:h-[50vh] col-span-2 w-full h-[19.9vh] xl-plus:h-full  bg-slate-700 overflow-hidden"
            >
              <div className="h-full w-full hover:scale-105   transition-transform transform duration-300 ease-in-out">
                <img
                  src={`${
                    width > 992
                      ? `/Gallery_img/${images[3]}.png`
                      : `/Gallery_img/mobile/${images[3]}.png`
                  }`}
                  alt={`Img ${images[2]}`}
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
          )
        : images[2] && (
            <div
              data-aos="fade-up"
              className="md:row-span-2 xl-plus:col-span-1 md:h-[50vh] col-span-2 w-full h-[30vh] xl-plus:h-full  bg-slate-700 overflow-hidden"
            >
              <div className="h-full w-full hover:scale-105   transition-transform transform duration-300 ease-in-out">
                <img
                  src={`${
                    width > 992
                      ? `/Gallery_img/${images[2]}.png`
                      : `/Gallery_img/mobile/${images[2]}.png`
                  }`}
                  alt={`Img ${images[2]}`}
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
          )}

      {width > 1280
        ? images[2] && (
            <div
              data-aos="fade-up"
              className="col-span-2  md:h-[50vh] pb-[4vw] md:pb-0 h-[19.9vh] overflow-hidden"
            >
              <div className="h-full w-full hover:scale-105   transition-transform transform duration-300 ease-in-out">
                <img
                  src={`${
                    width > 1280
                      ? `/Gallery_img/${images[2]}.png`
                      : `/Gallery_img/mobile/${images[2]}.png`
                  }`}
                  alt={`Img ${images[3]}`}
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
          )
        : images[3] && (
            <div
              data-aos="fade-up"
              className="col-span-2  md:h-[50vh] pb-[4vw] md:pb-0 h-[30vh] overflow-hidden"
            >
              <div className="h-full w-full hover:scale-105   transition-transform transform duration-300 ease-in-out">
                <img
                  src={`${
                    width > 1280
                      ? `/Gallery_img/${images[3]}.png`
                      : `/Gallery_img/mobile/${images[3]}.png`
                  }`}
                  alt={`Img ${images[3]}`}
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
          )}
    </div>
  );
};

export default GridImage;
